import React          from 'react';
import box_0          from '../images/box_0.png';
import box_1          from '../images/box_1.png';
import box_2          from '../images/box_2.png';
import box_3          from '../images/box_3.png';
import box_4          from '../images/box_4.png';
import box_5          from '../images/box_5.png';
import box_6          from '../images/box_6.png';
import box_7          from '../images/box_7.png';
import box_8          from '../images/box_8.png';
import box_9          from '../images/box_9.png';
import box_10         from '../images/box_10.png';
import closedBox      from '../images/closedBox.png';

import { makeStyles } from '@material-ui/core/styles';


const imageWidth = '15vw';
//const imageWidth = '30%';

const arr = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, box_10];

const useStyles = makeStyles(() => ({
    root: {
        width:          '100%',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
    },
    image10: {
   //   width:              '40%',
      height:             '100%',
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
      display:            'flex',
      alignItems:         'center',
      flexFlow:           'column',
      backgroundImage:    `url(${ closedBox })`,
    },
    image: {
        height:             '100%',
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        display:            'flex',
        alignItems:         'center',
        flexFlow:           'column',
    }
    
}))

type EggBoxProps = {
    wideScreen:  boolean;
    value:       number;
    imgSize?:    number[]
    closeAtTen?: boolean;
    shrink?:     boolean;
    onClick?:    () => void;
}

const EggBox: React.FC<EggBoxProps> = ({ wideScreen, value, imgSize, closeAtTen, shrink, onClick }) => {

  const classes = useStyles();

  const [imagesrc, setImageSrc] = React.useState(arr[value])

   React.useEffect(() => {

    setImageSrc((value === -1 || value === 20) ? closedBox : value > 10 ? arr[value - 10] : arr[value]);

    if (closeAtTen && value === 10) {
      setTimeout(() => {
        setImageSrc(closedBox)
      },3000)
    }
  },[value, closeAtTen]) 

  const [rootStyle, imageStyle] = React.useMemo(() => {
      return [
        {
          height: imgSize ? imgSize[1] : wideScreen ? 90 : 40,
        },
        {
           backgroundImage: `url(${ imagesrc })`,
           width:           imageWidth,//'30%',//shrink ? '27%' : value > 10 ? '40%' : '90%'
           marginLeft:      10,
           marginRight:     10,
        }
       ]
  },[wideScreen, imgSize, imagesrc/*, value , shrink */])

  return (
    <div 
        className = { classes.root }
        style     = { rootStyle }
    >
        {
          value > 10
          &&
          <div 
             className    = { classes.image10 }
             onMouseDown  = { onClick }
             onTouchStart = { onClick }
             style        = {{
              width: imageWidth
             }}
             
          />
        }
        <div 
           className    = { classes.image }
           style        = { imageStyle }
           onMouseDown  = { onClick }
           onTouchStart = { onClick }
        />
    </div>
  );
}



export default EggBox;








